import styled from 'styled-components';

type TVitalIndicatorSC = {
  color: string;
};

export const VitalIndicatorSC = styled.div<TVitalIndicatorSC>`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 28px;
  height: 10px;
  background: ${({ color }) => color};
  border-radius: 14px;
  box-shadow: 0 3px 4px rgba(51, 61, 108, 0.2);
  border: 3px solid #fefefe;
`;
